import styled from 'styled-components';
import MuiPaper from '@material-ui/core/Paper';

export const Container = styled.div`
`;

export const Paper = styled(MuiPaper)`
`;